var items = {
  "block.minecraft.air": "हवा",
  "block.minecraft.stone": "पत्थर",
  "block.minecraft.granite": "ग्रेनाइट",
  "block.minecraft.polished_granite": "चिकना ग्रेनाइट",
  "block.minecraft.diorite": "डायोराइट",
  "block.minecraft.polished_diorite": "चिकना डायोराइट",
  "block.minecraft.andesite": "एंडेसाइट",
  "block.minecraft.polished_andesite": "चिकना एंडेसाइट",
  "block.minecraft.grass_block": "घास का प्रखंड",
  "block.minecraft.dirt": "मिट्टी",
  "block.minecraft.coarse_dirt": "रूखा मिट्टी",
  "block.minecraft.podzol": "पोडज़ोल",
  "block.minecraft.crimson_nylium": "क्रिमसन नयलियम",
  "block.minecraft.warped_nylium": "नीली नर्फूई",
  "block.minecraft.cobblestone": "फर्शी पत्‍थर",
  "block.minecraft.oak_planks": "बाँज का तख्ता",
  "block.minecraft.spruce_planks": "प्रसरल का तख्ता",
  "block.minecraft.birch_planks": "भूर्ज का तख्ता",
  "block.minecraft.jungle_planks": "जंगल का तख्ता",
  "block.minecraft.acacia_planks": "बबूल का तख्ता",
  "block.minecraft.dark_oak_planks": "काला बाँज का तख्ता",
  "block.minecraft.crimson_planks": "किरमिजी तख्तें",
  "block.minecraft.warped_planks": "विकृत तख्तें",
  "block.minecraft.oak_sapling": "बाँज का पौधा",
  "block.minecraft.spruce_sapling": "प्रसरल का पौधा",
  "block.minecraft.birch_sapling": "भूर्ज का पौधा",
  "block.minecraft.jungle_sapling": "जंगल का पौधा",
  "block.minecraft.acacia_sapling": "बबूल का पौधा",
  "block.minecraft.dark_oak_sapling": "काला बाँज का पौधा",
  "block.minecraft.bedrock": "आधार-शैल",
  "block.minecraft.sand": "रेत",
  "block.minecraft.red_sand": "लाल रेत",
  "block.minecraft.gravel": "बजरी",
  "block.minecraft.gold_ore": "सोने का अयस्क",
  "block.minecraft.iron_ore": "लौह अयस्क",
  "block.minecraft.coal_ore": "कोयला अयस्क",
  "block.minecraft.nether_gold_ore": "नेदर के सोने का अयस्क",
  "block.minecraft.oak_log": "ओक लोगो",
  "block.minecraft.spruce_log": "प्रसरल लॉग",
  "block.minecraft.birch_log": "बिर्च लॉग",
  "block.minecraft.jungle_log": "जंगल लोगो",
  "block.minecraft.acacia_log": "बबूल लोग",
  "block.minecraft.dark_oak_log": "डार्क ओक लॉग",
  "block.minecraft.crimson_stem": "किरमिजी तना",
  "block.minecraft.warped_stem": "विकृत तना",
  "block.minecraft.stripped_oak_log": "धारीदार ओक लॉग",
  "block.minecraft.stripped_spruce_log": "स्ट्रिप्ड स्प्रूस लॉग",
  "block.minecraft.stripped_birch_log": "छीन लिया सन्टी का लट्ठा",
  "block.minecraft.stripped_jungle_log": "छीन लिया जंगल लॉग",
  "block.minecraft.stripped_acacia_log": "बबूल छीन लिया लॉग",
  "block.minecraft.stripped_dark_oak_log": "स्ट्रिप्ड डार्क ओक लॉग",
  "block.minecraft.stripped_crimson_stem": "छीना हुआ किरमिजी तना",
  "block.minecraft.stripped_warped_stem": "छीना हुआ विकृत तना",
  "block.minecraft.stripped_oak_wood": "छीना हुआ बाँज की लकड़ी",
  "block.minecraft.stripped_spruce_wood": "छीना हुआ प्रसरल की लकड़ी",
  "block.minecraft.stripped_birch_wood": "छीना हुआ भूर्ज की लकड़ी",
  "block.minecraft.stripped_jungle_wood": "छीना हुआ जंगल की लकड़ी",
  "block.minecraft.stripped_acacia_wood": "छीना हुआ बबूल की लकड़ी",
  "block.minecraft.stripped_dark_oak_wood": "छीना हुआ काला बाँज की लकड़ी",
  "block.minecraft.stripped_crimson_hyphae": "छीना हुआ किरमिजी कवकतंतुएँ",
  "block.minecraft.stripped_warped_hyphae": "छीना हुआ विकृत कवकतंतुएँ",
  "block.minecraft.oak_wood": "बाँज की लकड़ी",
  "block.minecraft.spruce_wood": "प्रसरल की लकड़ी",
  "block.minecraft.birch_wood": "भूर्ज की लकड़ी",
  "block.minecraft.jungle_wood": "जंगल की लकड़ी",
  "block.minecraft.acacia_wood": "बबूल की लकड़ी",
  "block.minecraft.dark_oak_wood": "काला बाँज की लकड़ी",
  "block.minecraft.crimson_hyphae": "किरमिजी कवकतंतुएँ",
  "block.minecraft.warped_hyphae": "विकृत कवकतंतुएँ",
  "block.minecraft.oak_leaves": "बाँज के पत्तें",
  "block.minecraft.spruce_leaves": "प्रसरल के पत्तें",
  "block.minecraft.birch_leaves": "भूर्ज के पत्तें",
  "block.minecraft.jungle_leaves": "जंगल के पत्तें",
  "block.minecraft.acacia_leaves": "बबूल के पत्तें",
  "block.minecraft.dark_oak_leaves": "काला बाँज के पत्तें",
  "block.minecraft.sponge": "स्पंज",
  "block.minecraft.wet_sponge": "गीला स्पंज",
  "block.minecraft.glass": "काँच",
  "block.minecraft.lapis_ore": "लाजवर्द का अयस्क",
  "block.minecraft.lapis_block": "लाजवर्द का प्रखंड",
  "block.minecraft.dispenser": "दवासाज़",
  "block.minecraft.sandstone": "बलुआ पत्थर",
  "block.minecraft.chiseled_sandstone": "छेनी वाला बलुआ पत्थर",
  "block.minecraft.cut_sandstone": "कटा हुआ बलुआ पत्थर",
  "block.minecraft.note_block": "नोट ब्लॉक",
  "block.minecraft.powered_rail": "संचालित रेल",
  "block.minecraft.detector_rail": "वेक्षक रेल",
  "block.minecraft.sticky_piston": "स्टिकी पिस्टन",
  "block.minecraft.cobweb": "मकड़जाल",
  "block.minecraft.grass": "घास",
  "block.minecraft.fern": "फर्न",
  "block.minecraft.dead_bush": "मृत पौधा",
  "block.minecraft.seagrass": "समुद्री घास",
  "block.minecraft.sea_pickle": "समुद्र का अचार",
  "block.minecraft.piston": "पिस्टन",
  "block.minecraft.white_wool": "सफेद ऊन",
  "block.minecraft.orange_wool": "नारंगी ऊन",
  "block.minecraft.magenta_wool": "नीलातिरक्त ऊन",
  "block.minecraft.light_blue_wool": "हल्का नीला ऊन",
  "block.minecraft.yellow_wool": "पीला ऊन",
  "block.minecraft.lime_wool": "लाइम ऊन",
  "block.minecraft.pink_wool": "गुलाबी ऊन",
  "block.minecraft.gray_wool": "स्लेटी ऊन",
  "block.minecraft.light_gray_wool": "हल्का स्लेटी ऊन",
  "block.minecraft.cyan_wool": "हरिनील ऊन",
  "block.minecraft.purple_wool": "जामुनी ऊन",
  "block.minecraft.blue_wool": "नीला ऊन",
  "block.minecraft.brown_wool": "भूरा ऊन",
  "block.minecraft.green_wool": "हरा ऊन",
  "block.minecraft.red_wool": "लाल ऊन",
  "block.minecraft.black_wool": "काला ऊन",
  "block.minecraft.dandelion": "सिंहपर्णी",
  "block.minecraft.poppy": "पोस्त",
  "block.minecraft.blue_orchid": "नीला ऑर्किड",
  "block.minecraft.allium": "प्याज फूल",
  "block.minecraft.azure_bluet": "नीला बलुएट",
  "block.minecraft.red_tulip": "लाल कंद-पुष्प",
  "block.minecraft.orange_tulip": "नारंगी कंद-पुष्प",
  "block.minecraft.white_tulip": "सफेद कंद-पुष्प",
  "block.minecraft.pink_tulip": "गुलाबी कंद-पुष्प",
  "block.minecraft.oxeye_daisy": "गुलबहार",
  "block.minecraft.cornflower": "मकई का फूल",
  "block.minecraft.lily_of_the_valley": "घाटी के लिली",
  "block.minecraft.wither_rose": "विदर गुलाब",
  "block.minecraft.brown_mushroom": "भूरा कुकुरमुत्ता",
  "block.minecraft.red_mushroom": "लाल कुकुरमुत्ता",
  "block.minecraft.crimson_fungus": "किरमिजी कवक",
  "block.minecraft.warped_fungus": "विकृत कवक",
  "block.minecraft.crimson_roots": "किरमिजी जड़ें",
  "block.minecraft.warped_roots": "विकृत जड़ें",
  "block.minecraft.nether_sprouts": "नेदर के अंकुर",
  "block.minecraft.weeping_vines": "रिसती बेलों",
  "block.minecraft.twisting_vines": "घुमावदार बेलों",
  "block.minecraft.sugar_cane": "गन्ना",
  "block.minecraft.kelp": "सिवार",
  "block.minecraft.bamboo": "बाँस",
  "block.minecraft.gold_block": "सोना का प्रखंड",
  "block.minecraft.iron_block": "लोहा का प्रखंड",
  "block.minecraft.oak_slab": "बाँज की पटिया",
  "block.minecraft.spruce_slab": "प्रसरल की पटिया",
  "block.minecraft.birch_slab": "भूर्ज की पटिया",
  "block.minecraft.jungle_slab": "जंगल की पटिया",
  "block.minecraft.acacia_slab": "बबूल की पटिया",
  "block.minecraft.dark_oak_slab": "काला बाँज की पटिया",
  "block.minecraft.crimson_slab": "किरमिजीक पटिया",
  "block.minecraft.warped_slab": "विकृत पटिया",
  "block.minecraft.stone_slab": "पत्थर की पटिया",
  "block.minecraft.smooth_stone_slab": "चिकना पत्थर की पटिया",
  "block.minecraft.sandstone_slab": "बलुआ पत्थर की पटिया",
  "block.minecraft.cut_sandstone_slab": "कटा हुआ बलुआ पत्थर की पटिया",
  "block.minecraft.petrified_oak_slab": "पेट्रिफ़ाइड ओक स्लैब",
  "block.minecraft.cobblestone_slab": "फर्शी पत्‍थर की पटिया",
  "block.minecraft.brick_slab": "ईंट की पटिया",
  "block.minecraft.stone_brick_slab": "पत्थर की ईंट की पटिया",
  "block.minecraft.nether_brick_slab": "नेदर ईंट की पटिया",
  "block.minecraft.quartz_slab": "स्फटिक की पटिया",
  "block.minecraft.red_sandstone_slab": "लाल बलुआ पत्थर की पटिया",
  "block.minecraft.cut_red_sandstone_slab": "कटा हुआ लाल बलुआ पत्थर की पटिया",
  "block.minecraft.purpur_slab": "परपर की पटिया",
  "block.minecraft.prismarine_slab": "प्रिज्मरीन की पटिया",
  "block.minecraft.prismarine_brick_slab": "प्रिज्मरीन ईंट की पटिया",
  "block.minecraft.dark_prismarine_slab": "काला प्रिज्मरीन की पटिया",
  "block.minecraft.smooth_quartz": "चिकना स्फटिक का प्रखंड",
  "block.minecraft.smooth_red_sandstone": "चिकनी लाल बलुआ पत्थर",
  "block.minecraft.smooth_sandstone": "चिकनी बलुआ पत्थर",
  "block.minecraft.smooth_stone": "चिकना पत्थर",
  "block.minecraft.bricks": "ईंटें",
  "block.minecraft.tnt": "टीएनटी",
  "block.minecraft.bookshelf": "पुस्ताक तख्ता",
  "block.minecraft.mossy_cobblestone": "काई का फर्शी पत्‍थर",
  "block.minecraft.obsidian": "ज्वालाकाच",
  "block.minecraft.torch": "मशाल",
  "block.minecraft.end_rod": "एंड रोड",
  "block.minecraft.chorus_plant": "कोरस संयंत्र",
  "block.minecraft.chorus_flower": "कोरस फूल",
  "block.minecraft.purpur_block": "परपर का प्रखंड",
  "block.minecraft.purpur_pillar": "परपर का स्तंभ",
  "block.minecraft.purpur_stairs": "परपर की सीढ़ियाँ",
  "block.minecraft.spawner": "स्पॉनर",
  "block.minecraft.oak_stairs": "बाँज की सीढ़ियाँ",
  "block.minecraft.chest": "बक्सा",
  "block.minecraft.diamond_ore": "हीरक अयस्क",
  "block.minecraft.diamond_block": "हीरा का प्रखंड",
  "block.minecraft.crafting_table": "क्राफ्टिंग मैज़",
  "block.minecraft.farmland": "खेत",
  "block.minecraft.furnace": "भट्ठी",
  "block.minecraft.ladder": "सीढ़ी",
  "block.minecraft.rail": "रेल",
  "block.minecraft.cobblestone_stairs": "फर्शी पत्‍थर की सीढ़ियाँ",
  "block.minecraft.lever": "उत्तोलक",
  "block.minecraft.stone_pressure_plate": "पत्थर का दाब पट्ट",
  "block.minecraft.oak_pressure_plate": "बाँज का दाब पट्ट",
  "block.minecraft.spruce_pressure_plate": "प्रसरल का दाब पट्ट",
  "block.minecraft.birch_pressure_plate": "भूर्ज का दाब पट्ट",
  "block.minecraft.jungle_pressure_plate": "जंगल का दाब पट्ट",
  "block.minecraft.acacia_pressure_plate": "बबूल का दाब पट्ट",
  "block.minecraft.dark_oak_pressure_plate": "काला बाँज का दाब पट्ट",
  "block.minecraft.crimson_pressure_plate": "किरमिजी दाब पट्ट",
  "block.minecraft.warped_pressure_plate": "विकृत दाब पट्ट",
  "block.minecraft.polished_blackstone_pressure_plate": "चमकदार कालापाषाण का दाब पट्ट",
  "block.minecraft.redstone_ore": "रेडस्टोन का अयस्क",
  "block.minecraft.redstone_torch": "रेडस्टोन की मशाल",
  "block.minecraft.snow": "हिम",
  "block.minecraft.ice": "बर्फ",
  "block.minecraft.snow_block": "बरफ का ब्लॉक",
  "block.minecraft.cactus": "नागफनी",
  "block.minecraft.clay": "मृत्तिका",
  "block.minecraft.jukebox": "संगीत-यंत्र",
  "block.minecraft.oak_fence": "बाँज का बाड़ा",
  "block.minecraft.spruce_fence": "प्रसरल का बाड़ा",
  "block.minecraft.birch_fence": "भूर्ज का बाड़ा",
  "block.minecraft.jungle_fence": "जंगल का बाड़ा",
  "block.minecraft.acacia_fence": "बबूल का बाड़ा",
  "block.minecraft.dark_oak_fence": "काला बाँज का बाड़ा",
  "block.minecraft.crimson_fence": "किरमिजी बाड़",
  "block.minecraft.warped_fence": "विकृत बाड़",
  "block.minecraft.pumpkin": "कद्दू",
  "block.minecraft.carved_pumpkin": "नक्काशीदार कद्दू",
  "block.minecraft.netherrack": "नेदररैक",
  "block.minecraft.soul_sand": "आत्मा की रेत",
  "block.minecraft.soul_soil": "आत्माओं की भूमि",
  "block.minecraft.basalt": "असिताश्म",
  "block.minecraft.polished_basalt": "चमकदार असिताश्म",
  "block.minecraft.soul_torch": "आत्मा की मशाल",
  "block.minecraft.glowstone": "चमकीला पथर",
  "block.minecraft.jack_o_lantern": "कदु की लालटेन",
  "block.minecraft.oak_trapdoor": "बाँज का कूट द्वार",
  "block.minecraft.spruce_trapdoor": "प्रसरल का कूट द्वार",
  "block.minecraft.birch_trapdoor": "भूर्ज का कूट द्वार",
  "block.minecraft.jungle_trapdoor": "जंगल का कूट द्वार",
  "block.minecraft.acacia_trapdoor": "बबूल का कूट द्वार",
  "block.minecraft.dark_oak_trapdoor": "काला बाँज का कूट द्वार",
  "block.minecraft.crimson_trapdoor": "किरमिजी कूट द्वार",
  "block.minecraft.warped_trapdoor": "विकृत कूट द्वार",
  "block.minecraft.infested_stone": "संक्रमित पत्थर",
  "block.minecraft.infested_cobblestone": "संक्रमित फर्शी पत्‍थर",
  "block.minecraft.infested_stone_bricks": "संक्रमित पत्थर की ईंटें",
  "block.minecraft.infested_mossy_stone_bricks": "संक्रमित दरदर का पत्थर की ईंटें",
  "block.minecraft.infested_cracked_stone_bricks": "संक्रमित टूटा हुआ पत्थर की ईंटें",
  "block.minecraft.infested_chiseled_stone_bricks": "संक्रमित तराशा हुआ पत्थर की ईंटें",
  "block.minecraft.stone_bricks": "पत्थर की ईंटें",
  "block.minecraft.mossy_stone_bricks": "दलदल का पत्थर की ईंटें",
  "block.minecraft.cracked_stone_bricks": "टूटा हुआ पत्थर की ईंटें",
  "block.minecraft.chiseled_stone_bricks": "तराशा हुआ पत्थर की ईंटें",
  "block.minecraft.brown_mushroom_block": "भूरा कुकुरमुत्ता का प्रखंड",
  "block.minecraft.red_mushroom_block": "लाल कुकुरमुत्ता का प्रखंड",
  "block.minecraft.mushroom_stem": "कुकुरमुत्ता का तना",
  "block.minecraft.iron_bars": "लौह छड़",
  "block.minecraft.chain": "जंजीर",
  "block.minecraft.glass_pane": "खिड़की का काँच",
  "block.minecraft.melon": "खरबूज",
  "block.minecraft.vine": "बेलें",
  "block.minecraft.oak_fence_gate": "बाँज का फाटक",
  "block.minecraft.spruce_fence_gate": "प्रसरल का फाटक",
  "block.minecraft.birch_fence_gate": "भूर्ज का फाटक",
  "block.minecraft.jungle_fence_gate": "जंगल का फाटक",
  "block.minecraft.acacia_fence_gate": "बबूल का फाटक",
  "block.minecraft.dark_oak_fence_gate": "काला बाँज का फाटक",
  "block.minecraft.crimson_fence_gate": "किरमिजी फाटक",
  "block.minecraft.warped_fence_gate": "विकृत फाटक",
  "block.minecraft.brick_stairs": "ईंट की सीढ़ियाँ",
  "block.minecraft.stone_brick_stairs": "पत्थर की ईंट की सीढ़ियाँ",
  "block.minecraft.mycelium": "कवकजाल",
  "block.minecraft.lily_pad": "लिली तकती",
  "block.minecraft.nether_bricks": "नेदर के ईंटें",
  "block.minecraft.cracked_nether_bricks": "टूटी हुई नेदर की ईठें",
  "block.minecraft.chiseled_nether_bricks": "तराशी हुई नेदर की ईठें",
  "block.minecraft.nether_brick_fence": "नेदर की ईंट की बाड़",
  "block.minecraft.nether_brick_stairs": "नेदर की ईंट की सीढ़ियाँ",
  "block.minecraft.enchanting_table": "मंत्रमुग्ध कार्ने वाली मेज",
  "block.minecraft.end_portal_frame": "खतम द्वार का ढ़ांचा",
  "block.minecraft.end_stone": "एन्ड का पत्थर",
  "block.minecraft.end_stone_bricks": "एंड का पत्थर की ईंट",
  "block.minecraft.dragon_egg": "ड्रैगन का अंडा",
  "block.minecraft.redstone_lamp": "लाल पत्थर का दीपक",
  "block.minecraft.sandstone_stairs": "बलुआ पत्थर की सीढ़ियाँ",
  "block.minecraft.emerald_ore": "पन्ना का अयस्क",
  "block.minecraft.ender_chest": "अंतवह बक्सा",
  "block.minecraft.tripwire_hook": "गिराने की का तार का हुक",
  "block.minecraft.emerald_block": "एमराल्ड कआ ब्लॉक",
  "block.minecraft.spruce_stairs": "प्रसरल की सीढ़ियाँ",
  "block.minecraft.birch_stairs": "भूर्ज की सीढ़ियाँ",
  "block.minecraft.jungle_stairs": "जंगल की सीढ़ियाँ",
  "block.minecraft.crimson_stairs": "किरमिजी सीढ़ियाँ",
  "block.minecraft.warped_stairs": "विकृत सीढ़ियाँ",
  "block.minecraft.command_block": "समादेश प्रखंड",
  "block.minecraft.beacon": "आकाशदीप",
  "block.minecraft.cobblestone_wall": "फर्शी पत्‍थर का दीवार",
  "block.minecraft.mossy_cobblestone_wall": "काई का फर्शी पत्‍थर का दीवार",
  "block.minecraft.brick_wall": "ईंट की दीवार",
  "block.minecraft.prismarine_wall": "प्रिज्मरीन की दीवार",
  "block.minecraft.red_sandstone_wall": "लाल बलुआ पत्थर की दीवार",
  "block.minecraft.mossy_stone_brick_wall": "काई का पत्थर की ईंट की दीवार",
  "block.minecraft.granite_wall": "ग्रेनाइट की दीवार",
  "block.minecraft.stone_brick_wall": "पत्थर की ईंट की दीवार",
  "block.minecraft.nether_brick_wall": "नेदर ईंट की दीवार",
  "block.minecraft.andesite_wall": "एंडीसाइट का दीवार",
  "block.minecraft.red_nether_brick_wall": "लाल नेदर ईंट की दीवार",
  "block.minecraft.sandstone_wall": "बलुआ पत्थर की दीवार",
  "block.minecraft.end_stone_brick_wall": "एंड का पत्थर की ईंट की दीवार",
  "block.minecraft.diorite_wall": "डाओराइट का दीवार",
  "block.minecraft.blackstone_wall": "कालापाषाण की दीवार",
  "block.minecraft.polished_blackstone_wall": "चमकदार कालापाषाण की दीवार",
  "block.minecraft.polished_blackstone_brick_wall": "चमकदार कालापाषाण की ईंट की दीवार",
  "block.minecraft.stone_button": "पथरीला बटन",
  "block.minecraft.oak_button": "बाँज का बटन",
  "block.minecraft.spruce_button": "प्रसरल का बटन",
  "block.minecraft.birch_button": "भूर्ज का बटन",
  "block.minecraft.jungle_button": "जंगल का बटन",
  "block.minecraft.acacia_button": "बबूल का बटन",
  "block.minecraft.dark_oak_button": "काला बाँज का बटन",
  "block.minecraft.crimson_button": "किरमिजी बटन",
  "block.minecraft.warped_button": "विकृत बटन",
  "block.minecraft.polished_blackstone_button": "चमकदार कालापाषाण का बटन",
  "block.minecraft.anvil": "निहाई",
  "block.minecraft.chipped_anvil": "चिपकी हुई आँवला",
  "block.minecraft.damaged_anvil": "क्षतिग्रस्त अहरन",
  "block.minecraft.trapped_chest": "जाल बक्सा",
  "block.minecraft.light_weighted_pressure_plate": "हल्का भारित दाब पट्ट",
  "block.minecraft.heavy_weighted_pressure_plate": "भारी भारित दाब पट्ट",
  "block.minecraft.daylight_detector": "डेलाइट सेंसर",
  "block.minecraft.redstone_block": "लाल पत्थर कआ ब्लॉक",
  "block.minecraft.nether_quartz_ore": "नेदर स्फटिक का अयस्क",
  "block.minecraft.hopper": "कूदनेवाला",
  "block.minecraft.chiseled_quartz_block": "गढ़े हुए क्वार्ट्ज ब्लॉक",
  "block.minecraft.quartz_block": "स्फटिक का प्रखंड",
  "block.minecraft.quartz_bricks": "स्फटिक की ईंटे",
  "block.minecraft.quartz_pillar": "स्फटिक का स्तंभ",
  "block.minecraft.quartz_stairs": "स्फटिक की सीढ़ियाँ",
  "block.minecraft.activator_rail": "उत्प्रेरक रेल",
  "block.minecraft.dropper": "गिराने की मशीन",
  "block.minecraft.white_terracotta": "सफेद टेराकोटा",
  "block.minecraft.orange_terracotta": "नारंगी टेराकोटा",
  "block.minecraft.magenta_terracotta": "नीलातिरक्त टेराकोटा",
  "block.minecraft.light_blue_terracotta": "हल्का नीला टेराकोटा",
  "block.minecraft.yellow_terracotta": "पीला टेराकोटा",
  "block.minecraft.lime_terracotta": "लाइम टेराकोटा",
  "block.minecraft.pink_terracotta": "गुलाबी टेराकोटा",
  "block.minecraft.gray_terracotta": "स्लेटी टेराकोटा",
  "block.minecraft.light_gray_terracotta": "हल्का स्लेटी टेराकोटा",
  "block.minecraft.cyan_terracotta": "हरिनील टेराकोटा",
  "block.minecraft.purple_terracotta": "जामुनी टेराकोटा",
  "block.minecraft.blue_terracotta": "नीला टेराकोटा",
  "block.minecraft.brown_terracotta": "भूरा टेराकोटा",
  "block.minecraft.green_terracotta": "हरा टेराकोटा",
  "block.minecraft.red_terracotta": "लाल टेराकोटा",
  "block.minecraft.black_terracotta": "काला टेराकोटा",
  "block.minecraft.barrier": "अवरोध",
  "block.minecraft.iron_trapdoor": "लोहे का कूट द्वार",
  "block.minecraft.hay_block": "सूखी घास की गठरी",
  "block.minecraft.white_carpet": "सफेद कालीन",
  "block.minecraft.orange_carpet": "नारंगी कालीन",
  "block.minecraft.magenta_carpet": "नीलातिरक्त कालीन",
  "block.minecraft.light_blue_carpet": "हल्का नीला कालीन",
  "block.minecraft.yellow_carpet": "पीला कालीन",
  "block.minecraft.lime_carpet": "लाइम कालीन",
  "block.minecraft.pink_carpet": "गुलाबी कालीन",
  "block.minecraft.gray_carpet": "स्लेटी कालीन",
  "block.minecraft.light_gray_carpet": "हल्का स्लेटी कालीन",
  "block.minecraft.cyan_carpet": "हरिनील कालीन",
  "block.minecraft.purple_carpet": "जामुनी कालीन",
  "block.minecraft.blue_carpet": "नीला कालीन",
  "block.minecraft.brown_carpet": "भूरा कालीन",
  "block.minecraft.green_carpet": "हरा कालीन",
  "block.minecraft.red_carpet": "लाल कालीन",
  "block.minecraft.black_carpet": "काला कालीन",
  "block.minecraft.terracotta": "टेराकोटा",
  "block.minecraft.coal_block": "कोयला का प्रखंड",
  "block.minecraft.packed_ice": "संकुलित बर्फ",
  "block.minecraft.acacia_stairs": "बबूल की सीढ़ियाँ",
  "block.minecraft.dark_oak_stairs": "काला बाँज की सीढ़ियाँ",
  "block.minecraft.slime_block": "कीचड़ ब्लॉक",
  "block.minecraft.grass_path": "घास पथ",
  "block.minecraft.sunflower": "सूरजमुखी",
  "block.minecraft.lilac": "नीलक",
  "block.minecraft.rose_bush": "गुलाब की झाड़ी",
  "block.minecraft.peony": "पीअनी",
  "block.minecraft.tall_grass": "लंबा घास",
  "block.minecraft.large_fern": "बड़ा फर्न",
  "block.minecraft.white_stained_glass": "सफेद अभिरंजित काँच",
  "block.minecraft.orange_stained_glass": "नारंगी अभिरंजित काँच",
  "block.minecraft.magenta_stained_glass": "नीलातिरक्त अभिरंजित काँच",
  "block.minecraft.light_blue_stained_glass": "हल्का नीला अभिरंजित काँच",
  "block.minecraft.yellow_stained_glass": "पीला अभिरंजित काँच",
  "block.minecraft.lime_stained_glass": "लाइम अभिरंजित काँच",
  "block.minecraft.pink_stained_glass": "गुलाबी अभिरंजित काँच",
  "block.minecraft.gray_stained_glass": "स्लेटी अभिरंजित काँच",
  "block.minecraft.light_gray_stained_glass": "हल्का स्लेटी अभिरंजित काँच",
  "block.minecraft.cyan_stained_glass": "हरिनील अभिरंजित काँच",
  "block.minecraft.purple_stained_glass": "जामुनी अभिरंजित काँच",
  "block.minecraft.blue_stained_glass": "नीला अभिरंजित काँच",
  "block.minecraft.brown_stained_glass": "भूरा अभिरंजित काँच",
  "block.minecraft.green_stained_glass": "हरा अभिरंजित काँच",
  "block.minecraft.red_stained_glass": "लाल अभिरंजित काँच",
  "block.minecraft.black_stained_glass": "काला अभिरंजित काँच",
  "block.minecraft.white_stained_glass_pane": "सफेद अभिरंजित खिड़की का काँच",
  "block.minecraft.orange_stained_glass_pane": "नारंगी अभिरंजित खिड़की का काँच",
  "block.minecraft.magenta_stained_glass_pane": "नीलातिरक्त अभिरंजित खिड़की का काँच",
  "block.minecraft.light_blue_stained_glass_pane": "हल्का नीला अभिरंजित खिड़की का काँच",
  "block.minecraft.yellow_stained_glass_pane": "पीला अभिरंजित खिड़की का काँच",
  "block.minecraft.lime_stained_glass_pane": "लाइम अभिरंजित खिड़की का काँच",
  "block.minecraft.pink_stained_glass_pane": "गुलाबी अभिरंजित खिड़की का काँच",
  "block.minecraft.gray_stained_glass_pane": "स्लेटी अभिरंजित खिड़की का काँच",
  "block.minecraft.light_gray_stained_glass_pane": "हल्का स्लेटी अभिरंजित खिड़की का काँच",
  "block.minecraft.cyan_stained_glass_pane": "हरिनील अभिरंजित खिड़की का काँच",
  "block.minecraft.purple_stained_glass_pane": "जामुनी अभिरंजित खिड़की का काँच",
  "block.minecraft.blue_stained_glass_pane": "नीला अभिरंजित खिड़की का काँच",
  "block.minecraft.brown_stained_glass_pane": "भूरा अभिरंजित खिड़की का काँच",
  "block.minecraft.green_stained_glass_pane": "हरा अभिरंजित खिड़की का काँच",
  "block.minecraft.red_stained_glass_pane": "लाल अभिरंजित खिड़की का काँच",
  "block.minecraft.black_stained_glass_pane": "काला अभिरंजित खिड़की का काँच",
  "block.minecraft.prismarine": "प्रिज्मरीन",
  "block.minecraft.prismarine_bricks": "प्रिज्मरीन की ईंटें",
  "block.minecraft.dark_prismarine": "काला प्रिज्मरीन",
  "block.minecraft.prismarine_stairs": "प्रिज्मरीन की सीढ़ियाँ",
  "block.minecraft.prismarine_brick_stairs": "प्रिज्मरीन की ईंट की सीढ़ियाँ",
  "block.minecraft.dark_prismarine_stairs": "काला प्रिज्मरीन की सीढ़ियाँ",
  "block.minecraft.sea_lantern": "सागर लालटेन",
  "block.minecraft.red_sandstone": "लाल बलुआ पत्थर",
  "block.minecraft.chiseled_red_sandstone": "छेनी वाला लाल बलुआ पत्थर",
  "block.minecraft.cut_red_sandstone": "कटा हुआ लाल बलुआ पत्थर",
  "block.minecraft.red_sandstone_stairs": "लाल बलुआ पत्थर की सीढ़ियाँ",
  "block.minecraft.repeating_command_block": "आदेश ब्लॉक दोहरा जा रहा है",
  "block.minecraft.chain_command_block": "श्रृंखला आदेश ब्लॉक",
  "block.minecraft.magma_block": "मैग्मा ब्लॉक",
  "block.minecraft.nether_wart_block": "नेदर मस्सा ब्लॉक",
  "block.minecraft.warped_wart_block": "नीला वार्ट ब्लॉक",
  "block.minecraft.red_nether_bricks": "लाल नेदर ईंटे",
  "block.minecraft.bone_block": "हड्डी का प्रखंड",
  "block.minecraft.structure_void": "संरचना शून्य",
  "block.minecraft.observer": "पर्यवेक्षक",
  "block.minecraft.shulker_box": "शल्कर बक्सा",
  "block.minecraft.white_shulker_box": "सफेद शल्कर बक्सा",
  "block.minecraft.orange_shulker_box": "नारंगी शूल्कर बॉक्स",
  "block.minecraft.magenta_shulker_box": "नीलातिरक्त शल्कर बक्सा",
  "block.minecraft.light_blue_shulker_box": "हल्का नीला शल्कर बक्सा",
  "block.minecraft.yellow_shulker_box": "पीला शल्कर बक्सा",
  "block.minecraft.lime_shulker_box": "लाइम शल्कर बक्सा",
  "block.minecraft.pink_shulker_box": "गुलाबी शल्कर बक्सा",
  "block.minecraft.gray_shulker_box": "स्लेटी शल्कर बक्सा",
  "block.minecraft.light_gray_shulker_box": "हल्का स्लेटी शल्कर बक्सा",
  "block.minecraft.cyan_shulker_box": "हरिनील शल्कर बक्सा",
  "block.minecraft.purple_shulker_box": "जामुनी शल्कर बक्सा",
  "block.minecraft.blue_shulker_box": "नीला शल्कर बक्सा",
  "block.minecraft.brown_shulker_box": "भूरा शल्कर बक्सा",
  "block.minecraft.green_shulker_box": "हरा शल्कर बक्सा",
  "block.minecraft.red_shulker_box": "लाल शल्कर बक्सा",
  "block.minecraft.black_shulker_box": "काला शल्कर बक्सा",
  "block.minecraft.white_glazed_terracotta": "सफेद चमकदार टेराकोटा",
  "block.minecraft.orange_glazed_terracotta": "टेराकोटा नारंगी चमकता",
  "block.minecraft.magenta_glazed_terracotta": "मेजेन्टा चमकदार टेराकोटा",
  "block.minecraft.light_blue_glazed_terracotta": "हल्का नीला चमकदार टेराकोटा",
  "block.minecraft.yellow_glazed_terracotta": "पीला चमकदार टेराकोटा",
  "block.minecraft.lime_glazed_terracotta": "नींबू चमकदार टेराकोटा",
  "block.minecraft.pink_glazed_terracotta": "गुलाबी चमकता टेराकोटा",
  "block.minecraft.gray_glazed_terracotta": "ग्रे चमकदार टेराकोटा",
  "block.minecraft.light_gray_glazed_terracotta": "हल्का ग्रे चमकदार टेराकोटा",
  "block.minecraft.cyan_glazed_terracotta": "सियान चमकदार टेराकोटा",
  "block.minecraft.purple_glazed_terracotta": "बैंगनी चमकता टेराकोटा",
  "block.minecraft.blue_glazed_terracotta": "नीला चमकदार टेराकोटा",
  "block.minecraft.brown_glazed_terracotta": "ब्राउन चमकदार टेराकोटा",
  "block.minecraft.green_glazed_terracotta": "ग्रीन ग्लाज़ेड टेराकोटा",
  "block.minecraft.red_glazed_terracotta": "लाल चमकता टेराकोटा",
  "block.minecraft.black_glazed_terracotta": "काली चमकदार टेराकोटा",
  "block.minecraft.white_concrete": "सफेद कंक्रीट",
  "block.minecraft.orange_concrete": "नारंगी कंक्रीट",
  "block.minecraft.magenta_concrete": "नीलातिरक्त कंक्रीट",
  "block.minecraft.light_blue_concrete": "हल्का नीला कंक्रीट",
  "block.minecraft.yellow_concrete": "पीला कंक्रीट",
  "block.minecraft.lime_concrete": "लाइम कंक्रीट",
  "block.minecraft.pink_concrete": "गुलाबी कंक्रीट",
  "block.minecraft.gray_concrete": "स्लेटी कंक्रीट",
  "block.minecraft.light_gray_concrete": "हल्का स्लेटी कंक्रीट",
  "block.minecraft.cyan_concrete": "हरिनील कंक्रीट",
  "block.minecraft.purple_concrete": "जामुनी कंक्रीट",
  "block.minecraft.blue_concrete": "नीला कंक्रीट",
  "block.minecraft.brown_concrete": "भूरा कंक्रीट",
  "block.minecraft.green_concrete": "हरा कंक्रीट",
  "block.minecraft.red_concrete": "लाल कंक्रीट",
  "block.minecraft.black_concrete": "काला कंक्रीट",
  "block.minecraft.white_concrete_powder": "सफेद कंक्रीट का चूरा",
  "block.minecraft.orange_concrete_powder": "नारंगी कंक्रीट का चूरा",
  "block.minecraft.magenta_concrete_powder": "नीलातिरक्त कंक्रीट का चूरा",
  "block.minecraft.light_blue_concrete_powder": "हल्का नीला कंक्रीट का चूरा",
  "block.minecraft.yellow_concrete_powder": "पीला कंक्रीट का चूरा",
  "block.minecraft.lime_concrete_powder": "लाइम कंक्रीट का चूरा",
  "block.minecraft.pink_concrete_powder": "गुलाबी कंक्रीट का चूरा",
  "block.minecraft.gray_concrete_powder": "स्लेटी कंक्रीट का चूरा",
  "block.minecraft.light_gray_concrete_powder": "हल्का स्लेटी कंक्रीट का चूरा",
  "block.minecraft.cyan_concrete_powder": "हरिनील कंक्रीट का चूरा",
  "block.minecraft.purple_concrete_powder": "जामुनी कंक्रीट का चूरा",
  "block.minecraft.blue_concrete_powder": "नीला कंक्रीट का चूरा",
  "block.minecraft.brown_concrete_powder": "भूरा कंक्रीट का चूरा",
  "block.minecraft.green_concrete_powder": "हरा कंक्रीट का चूरा",
  "block.minecraft.red_concrete_powder": "लाल कंक्रीट का चूरा",
  "block.minecraft.black_concrete_powder": "काला कंक्रीट का चूरा",
  "block.minecraft.turtle_egg": "कछुआ का अंडा",
  "block.minecraft.dead_tube_coral_block": "मृत ट्यूब कोरल ब्लॉक",
  "block.minecraft.dead_brain_coral_block": "मृत बुद्धि का मूँगा का प्रखंड",
  "block.minecraft.dead_bubble_coral_block": "मृत बुलबुला का मूँगा का प्रखंड",
  "block.minecraft.dead_fire_coral_block": "मृत आग का मूँगा का प्रखंड",
  "block.minecraft.dead_horn_coral_block": "मृत सींग का मूँगा का प्रखंड",
  "block.minecraft.tube_coral_block": "नलिका का मूँगा का प्रखंड",
  "block.minecraft.brain_coral_block": "बुद्धि का मूँगा का प्रखंड",
  "block.minecraft.bubble_coral_block": "बुलबुला का मूँगा का प्रखंड",
  "block.minecraft.fire_coral_block": "आग का मूँगा का प्रखंड",
  "block.minecraft.horn_coral_block": "सींग का मूँगा का प्रखंड",
  "block.minecraft.tube_coral": "नलिका का मूँगा",
  "block.minecraft.brain_coral": "बुद्धि का मूँगा",
  "block.minecraft.bubble_coral": "बुलबुला का मूँगा",
  "block.minecraft.fire_coral": "आग का मूँगा",
  "block.minecraft.horn_coral": "सींग का मूँगा",
  "block.minecraft.dead_brain_coral": "मृत बुद्धि का मूँगा",
  "block.minecraft.dead_bubble_coral": "मृत बुलबुला का मूँगा",
  "block.minecraft.dead_fire_coral": "मृत आग का मूँगा",
  "block.minecraft.dead_horn_coral": "मृत सींग का मूँगा",
  "block.minecraft.dead_tube_coral": "मृत नलिका का मूँगा",
  "block.minecraft.tube_coral_fan": "नलिका का मूँगा का पंखा",
  "block.minecraft.brain_coral_fan": "बुद्धि का मूँगा का पंखा",
  "block.minecraft.bubble_coral_fan": "बुलबुला का मूँगा का पंखा",
  "block.minecraft.fire_coral_fan": "आग का मूँगा का पंखा",
  "block.minecraft.horn_coral_fan": "सींग का मूँगा का पंखा",
  "block.minecraft.dead_tube_coral_fan": "मृत नलिका का मूँगा का पंखा",
  "block.minecraft.dead_brain_coral_fan": "मृत बुद्धि का मूँगा का पंखा",
  "block.minecraft.dead_bubble_coral_fan": "मृत बुलबुला का मूँगा का पंखा",
  "block.minecraft.dead_fire_coral_fan": "मृत आग का मूँगा का पंखा",
  "block.minecraft.dead_horn_coral_fan": "मृत सींग का मूँगा का पंखा",
  "block.minecraft.blue_ice": "नीला बर्फ",
  "block.minecraft.conduit": "जलक्रोड",
  "block.minecraft.polished_granite_stairs": "चिकना ग्रेनाइट की सीढ़ियाँ",
  "block.minecraft.smooth_red_sandstone_stairs": "चिकनी लाल बलुआ पत्थर की सीढ़ियाँ",
  "block.minecraft.mossy_stone_brick_stairs": "काई का पत्थर की ईंट की सीढ़ियाँ",
  "block.minecraft.polished_diorite_stairs": "चिकना डाओराइट की सीढ़ियाँ",
  "block.minecraft.mossy_cobblestone_stairs": "काई का फर्शी पत्‍थर की सीढ़ियाँ",
  "block.minecraft.end_stone_brick_stairs": "एंड का पत्थर की ईंट की सीढ़ियाँ",
  "block.minecraft.stone_stairs": "पत्थर की सीढ़ियाँ",
  "block.minecraft.smooth_sandstone_stairs": "चिकनी बलुआ पत्थर की सीढ़ियाँ",
  "block.minecraft.smooth_quartz_stairs": "चिकना स्फटिक की सीढ़ियाँ",
  "block.minecraft.granite_stairs": "ग्रेनाइट की सीढ़ियाँ",
  "block.minecraft.andesite_stairs": "एंडीसाइट की सीढ़ियाँ",
  "block.minecraft.red_nether_brick_stairs": "लाल नेदर ईंट की सीढ़ियाँ",
  "block.minecraft.polished_andesite_stairs": "चिकना एंडेसाइट की सीढियाँ",
  "block.minecraft.diorite_stairs": "डाओराइट की सीढ़ियाँ",
  "block.minecraft.polished_granite_slab": "चिकना ग्रेनाइट की पटिया",
  "block.minecraft.smooth_red_sandstone_slab": "चिकना लाल बलुआ पत्थर की पटिया",
  "block.minecraft.mossy_stone_brick_slab": "काई का पत्थर की ईंट की पटिया",
  "block.minecraft.polished_diorite_slab": "चिकना डाओराइट की पटिया",
  "block.minecraft.mossy_cobblestone_slab": "काई का फर्शी पत्‍थर की पटिया",
  "block.minecraft.end_stone_brick_slab": "एंड का पत्थर की ईंट की पटिया",
  "block.minecraft.smooth_sandstone_slab": "चिकना बलुआ पत्थर की पटिया",
  "block.minecraft.smooth_quartz_slab": "चिकना स्फटिक की पटिया",
  "block.minecraft.granite_slab": "ग्रेनाइट की पटिया",
  "block.minecraft.andesite_slab": "एंडीसाइट की पटिया",
  "block.minecraft.red_nether_brick_slab": "लाल नेदर ईंट की पटिया",
  "block.minecraft.polished_andesite_slab": "चिकना एंडेसाइट की पटिया",
  "block.minecraft.diorite_slab": "डाओराइट की पटिया",
  "block.minecraft.scaffolding": "मचान",
  "block.minecraft.iron_door": "लौह दरवाजा",
  "block.minecraft.oak_door": "बाँज का दरवाजा",
  "block.minecraft.spruce_door": "प्रसरल का दरवाजा",
  "block.minecraft.birch_door": "भूर्ज का दरवाजा",
  "block.minecraft.jungle_door": "जंगल का दरवाजा",
  "block.minecraft.acacia_door": "बबूल का दरवाजा",
  "block.minecraft.dark_oak_door": "काला बाँज का दरवाजा",
  "block.minecraft.crimson_door": "किरमिजी दरवाजा",
  "block.minecraft.warped_door": "विकृत दरवाजा",
  "block.minecraft.repeater": "लाल पत्थर पुनरावर्तक",
  "block.minecraft.comparator": "लाल पत्थर तुलनित्र",
  "block.minecraft.structure_block": "ब्लॉक संरचना",
  "block.minecraft.jigsaw": "जिग्सॉ खंड",
  "item.minecraft.turtle_helmet": "कछुआ का खोल□□जब सिर पर है:□+2 कवच",
  "item.minecraft.scute": "प्रशल्क",
  "item.minecraft.iron_shovel": "लौह बेलचा□□जब मुख्य हाथ में है:□+3.5 हमले क्षति□-3 हमले की गति",
  "item.minecraft.iron_pickaxe": "लौह गैंती□□जब मुख्य हाथ में है:□+3 हमले क्षति□-2.8 हमले की गति",
  "item.minecraft.iron_axe": "लौह कुल्हाड़ी□□जब मुख्य हाथ में है:□+8 हमले क्षति□-3.1 हमले की गति",
  "item.minecraft.flint_and_steel": "अग्नि का प्रारंभक",
  "item.minecraft.apple": "सेब",
  "item.minecraft.bow": "धनुष",
  "item.minecraft.arrow": "तीर",
  "item.minecraft.coal": "कोयला",
  "item.minecraft.charcoal": "काठकोयला",
  "item.minecraft.diamond": "हीरा",
  "item.minecraft.iron_ingot": "लौह शिलिका",
  "item.minecraft.gold_ingot": "स्वर्ण पिंड",
  "item.minecraft.netherite_ingot": "नेदराइट का पिंड",
  "item.minecraft.netherite_scrap": "नेदराइट की टुकड़ी",
  "item.minecraft.iron_sword": "लोहे की तलवार□□जब मुख्य हाथ में है:□+5 हमले क्षति□-2.4 हमले की गति",
  "item.minecraft.wooden_sword": "लकड़ी की तलवार□□जब मुख्य हाथ में है:□+3 हमले क्षति□-2.4 हमले की गति",
  "item.minecraft.wooden_shovel": "लकड़ी का बेलचा□□जब मुख्य हाथ में है:□+1.5 हमले क्षति□-3 हमले की गति",
  "item.minecraft.wooden_pickaxe": "लकड़ी की गैंती□□जब मुख्य हाथ में है:□+1 हमले क्षति□-2.8 हमले की गति",
  "item.minecraft.wooden_axe": "लकड़ी की कुल्हाड़ी□□जब मुख्य हाथ में है:□+6 हमले क्षति□-3.2 हमले की गति",
  "item.minecraft.stone_sword": "पत्थर की तलवार□□जब मुख्य हाथ में है:□+4 हमले क्षति□-2.4 हमले की गति",
  "item.minecraft.stone_shovel": "पत्थर का बेलचा□□जब मुख्य हाथ में है:□+2.5 हमले क्षति□-3 हमले की गति",
  "item.minecraft.stone_pickaxe": "पत्थर की गैंती□□जब मुख्य हाथ में है:□+2 हमले क्षति□-2.8 हमले की गति",
  "item.minecraft.stone_axe": "पत्यक की कुल्हाड़ी□□जब मुख्य हाथ में है:□+8 हमले क्षति□-3.2 हमले की गति",
  "item.minecraft.diamond_sword": "हीरक तलवार□□जब मुख्य हाथ में है:□+6 हमले क्षति□-2.4 हमले की गति",
  "item.minecraft.diamond_shovel": "हीरक बेलचा□□जब मुख्य हाथ में है:□+4.5 हमले क्षति□-3 हमले की गति",
  "item.minecraft.diamond_pickaxe": "हीरक गैंती□□जब मुख्य हाथ में है:□+4 हमले क्षति□-2.8 हमले की गति",
  "item.minecraft.diamond_axe": "हीरक कुल्हाड़ी□□जब मुख्य हाथ में है:□+8 हमले क्षति□-3 हमले की गति",
  "item.minecraft.stick": "डंडा",
  "item.minecraft.bowl": "कटोरी",
  "item.minecraft.mushroom_stew": "मशरूम स्टू",
  "item.minecraft.golden_sword": "सोने की तलवार□□जब मुख्य हाथ में है:□+3 हमले क्षति□-2.4 हमले की गति",
  "item.minecraft.golden_shovel": "सोने का बेलचा□□जब मुख्य हाथ में है:□+1.5 हमले क्षति□-3 हमले की गति",
  "item.minecraft.golden_pickaxe": "सोने की गैंती□□जब मुख्य हाथ में है:□+1 हमले क्षति□-2.8 हमले की गति",
  "item.minecraft.golden_axe": "सोने की कुल्हाड़ी□□जब मुख्य हाथ में है:□+6 हमले क्षति□-3 हमले की गति",
  "item.minecraft.netherite_sword": "नेदराइट की तलवार□□जब मुख्य हाथ में है:□+7 हमले क्षति□-2.4 हमले की गति",
  "item.minecraft.netherite_shovel": "नेदराइट का फावड़ा□□जब मुख्य हाथ में है:□+5.5 हमले क्षति□-3 हमले की गति",
  "item.minecraft.netherite_pickaxe": "नेदराइट की कुदाली□□जब मुख्य हाथ में है:□+5 हमले क्षति□-2.8 हमले की गति",
  "item.minecraft.netherite_axe": "नेदराइट की कुल्हाड़ी□□जब मुख्य हाथ में है:□+9 हमले क्षति□-3 हमले की गति",
  "item.minecraft.string": "धागा",
  "item.minecraft.feather": "पंख",
  "item.minecraft.gunpowder": "बारूद",
  "item.minecraft.wooden_hoe": "लकड़ी की कुदाल□□जब मुख्य हाथ में है:□-3 हमले की गति",
  "item.minecraft.stone_hoe": "पत्थर की कुदाल□□जब मुख्य हाथ में है:□-2 हमले की गति",
  "item.minecraft.iron_hoe": "लौह कुदाल□□जब मुख्य हाथ में है:□-1 हमले की गति",
  "item.minecraft.diamond_hoe": "हीरक कुदाल□□जब मुख्य हाथ में है:",
  "item.minecraft.golden_hoe": "सोने की कुदाल□□जब मुख्य हाथ में है:□-3 हमले की गति",
  "item.minecraft.netherite_hoe": "नेदराइट का कुदाल□□जब मुख्य हाथ में है:",
  "item.minecraft.wheat_seeds": "गेहूँ के बीज",
  "item.minecraft.wheat": "गेहूँ",
  "item.minecraft.bread": "पाव",
  "item.minecraft.leather_helmet": "चमड़े का टोप□□जब सिर पर है:□+1 कवच",
  "item.minecraft.leather_chestplate": "चमड़े की छातीकवच□□जब शरीर पर है:□+3 कवच",
  "item.minecraft.leather_leggings": "चमड़े की टाँगकवच□□जब पैरों पर हैं:□+2 कवच",
  "item.minecraft.leather_boots": "चमड़े के जूते□□जब पाँव पर है:□+1 कवच",
  "item.minecraft.chainmail_helmet": "छल्लों का टोप□□जब सिर पर है:□+2 कवच",
  "item.minecraft.chainmail_chestplate": "छल्लों की छातीकवच□□जब शरीर पर है:□+5 कवच",
  "item.minecraft.chainmail_leggings": "छल्लों की टाँगकवच□□जब पैरों पर हैं:□+4 कवच",
  "item.minecraft.chainmail_boots": "छल्लों के जूते□□जब पाँव पर है:□+1 कवच",
  "item.minecraft.iron_helmet": "लौह टोप□□जब सिर पर है:□+2 कवच",
  "item.minecraft.iron_chestplate": "लौह छातीकवच□□जब शरीर पर है:□+6 कवच",
  "item.minecraft.iron_leggings": "लौह टाँगकवच□□जब पैरों पर हैं:□+5 कवच",
  "item.minecraft.iron_boots": "लौह जूते□□जब पाँव पर है:□+2 कवच",
  "item.minecraft.diamond_helmet": "हीरक टोप□□जब सिर पर है:□+3 कवच□+2 कवच की कठोरता",
  "item.minecraft.diamond_chestplate": "हीरक छातीकवच□□जब शरीर पर है:□+8 कवच□+2 कवच की कठोरता",
  "item.minecraft.diamond_leggings": "हीरक टाँगकवच□□जब पैरों पर हैं:□+6 कवच□+2 कवच की कठोरता",
  "item.minecraft.diamond_boots": "हीरक जूते□□जब पाँव पर है:□+3 कवच□+2 कवच की कठोरता",
  "item.minecraft.golden_helmet": "सोने का टोप□□जब सिर पर है:□+2 कवच",
  "item.minecraft.golden_chestplate": "सोने की छातीकवच□□जब शरीर पर है:□+5 कवच",
  "item.minecraft.golden_leggings": "सौने की टाँगकवच□□जब पैरों पर हैं:□+3 कवच",
  "item.minecraft.golden_boots": "सोने के जूते□□जब पाँव पर है:□+1 कवच",
  "item.minecraft.netherite_helmet": "नेदराइट का टोप□□जब सिर पर है:□+3 कवच□+3 कवच की कठोरता□+1 प्रतिरोध वापस दस्तक",
  "item.minecraft.netherite_chestplate": "नेदराइट की छातीकवच□□जब शरीर पर है:□+8 कवच□+3 कवच की कठोरता□+1 प्रतिरोध वापस दस्तक",
  "item.minecraft.netherite_leggings": "नेदराइट की टाँगकवच□□जब पैरों पर हैं:□+6 कवच□+3 कवच की कठोरता□+1 प्रतिरोध वापस दस्तक",
  "item.minecraft.netherite_boots": "नेदराइट के जूते□□जब पाँव पर है:□+3 कवच□+3 कवच की कठोरता□+1 प्रतिरोध वापस दस्तक",
  "item.minecraft.flint": "चकमक पत्थर",
  "item.minecraft.porkchop": "कच्चा सुअर",
  "item.minecraft.cooked_porkchop": "पक्व सुअर",
  "item.minecraft.painting": "चित्र",
  "item.minecraft.golden_apple": "सोने का सेब",
  "item.minecraft.enchanted_golden_apple": "जादूई सुनहेरा सेब",
  "block.minecraft.oak_sign": "बाँज का संकेत",
  "block.minecraft.spruce_sign": "प्रसरल का संकेत",
  "block.minecraft.birch_sign": "भूर्ज का संकेत",
  "block.minecraft.jungle_sign": "जंगल का संकेत",
  "block.minecraft.acacia_sign": "बबूल का संकेत",
  "block.minecraft.dark_oak_sign": "काला बाँज का संकेत",
  "block.minecraft.crimson_sign": "किरमिजी संकेत",
  "block.minecraft.warped_sign": "विकृत संकेत",
  "item.minecraft.bucket": "बाल्टी",
  "item.minecraft.water_bucket": "पानी की बाल्टी",
  "item.minecraft.lava_bucket": "लावा की बाल्टी",
  "item.minecraft.minecart": "गाड़ी",
  "item.minecraft.saddle": "काठी",
  "item.minecraft.redstone": "रेडस्टोन का चूरा",
  "item.minecraft.snowball": "बर्फ का गोला",
  "item.minecraft.oak_boat": "बाँज की नाव",
  "item.minecraft.leather": "चमड़ा",
  "item.minecraft.milk_bucket": "दूध की बाल्टी",
  "item.minecraft.pufferfish_bucket": "आध्मादतक मछली की बाल्टी",
  "item.minecraft.salmon_bucket": "सॅल्मन की बाल्टी",
  "item.minecraft.cod_bucket": "सीओडी की बाल्टी",
  "item.minecraft.tropical_fish_bucket": "उष्णकटिबंधीय मछली की बाल्टी",
  "item.minecraft.brick": "ईंट",
  "item.minecraft.clay_ball": "मृत्तिका का गोला",
  "block.minecraft.dried_kelp_block": "सूखा सिवार का प्रखंड",
  "item.minecraft.paper": "कागज",
  "item.minecraft.book": "पुस्तक",
  "item.minecraft.slime_ball": "कीचड़ बॉल",
  "item.minecraft.chest_minecart": "संदूक के साथ कार्ट",
  "item.minecraft.furnace_minecart": "फर्नेस के साथ कार्ट",
  "item.minecraft.egg": "अंडा",
  "item.minecraft.compass": "दिक्सूचक",
  "item.minecraft.fishing_rod": "बंसी",
  "item.minecraft.clock": "घड़ी",
  "item.minecraft.glowstone_dust": "चमक स्टोन डस्ट",
  "item.minecraft.cod": "कच्चा कॉड",
  "item.minecraft.salmon": "कच्चा सैल्मन",
  "item.minecraft.tropical_fish": "उष्ण मछ्ली",
  "item.minecraft.pufferfish": "आध्मादतक मछली",
  "item.minecraft.cooked_cod": "पक्क कॉड",
  "item.minecraft.cooked_salmon": "पक्व सैल्मन",
  "item.minecraft.ink_sac": "स्याही की बोरी",
  "item.minecraft.red_dye": "लाल रंजक",
  "item.minecraft.green_dye": "हरा रंजक",
  "item.minecraft.cocoa_beans": "कोको बीन्स",
  "item.minecraft.lapis_lazuli": "लापीस लाजुली",
  "item.minecraft.purple_dye": "जामुनी रंजक",
  "item.minecraft.cyan_dye": "हरिनील रंजक",
  "item.minecraft.light_gray_dye": "हल्का स्लेटी रंजक",
  "item.minecraft.gray_dye": "स्लेटी रंजक",
  "item.minecraft.pink_dye": "गुलाबी रंजक",
  "item.minecraft.lime_dye": "लाइम रंजक",
  "item.minecraft.yellow_dye": "पीला रंजक",
  "item.minecraft.light_blue_dye": "हल्का नीला रंजक",
  "item.minecraft.magenta_dye": "नीलातिरक्त रंजक",
  "item.minecraft.orange_dye": "नारंगी रंजक",
  "item.minecraft.bone_meal": "हड्डी का चूरा",
  "item.minecraft.blue_dye": "नीला रंजक",
  "item.minecraft.brown_dye": "भूरा रंजक",
  "item.minecraft.black_dye": "काला रंजक",
  "item.minecraft.white_dye": "सफेद रंजक",
  "item.minecraft.bone": "हड्डी",
  "item.minecraft.sugar": "चीनी",
  "block.minecraft.cake": "केक",
  "block.minecraft.white_bed": "सफेद बिस्तर",
  "block.minecraft.orange_bed": "नारंगी बिस्तर",
  "block.minecraft.magenta_bed": "नीलातिरक्त बिस्तर",
  "block.minecraft.light_blue_bed": "हल्का नीला बिस्तर",
  "block.minecraft.yellow_bed": "पीला बिस्तर",
  "block.minecraft.lime_bed": "लाइम बिस्तर",
  "block.minecraft.pink_bed": "गुलाबी बिस्तर",
  "block.minecraft.gray_bed": "स्लेटी बिस्तर",
  "block.minecraft.light_gray_bed": "हल्का स्लेटी बिस्तर",
  "block.minecraft.cyan_bed": "हरिनील बिस्तर",
  "block.minecraft.purple_bed": "गुलाबी बिस्तर",
  "block.minecraft.blue_bed": "नीला बिस्तर",
  "block.minecraft.brown_bed": "भूरा बिस्तर",
  "block.minecraft.green_bed": "हरा बिस्तर",
  "block.minecraft.red_bed": "लाल बिस्तर",
  "block.minecraft.black_bed": "काला बिस्तर",
  "item.minecraft.cookie": "बिस्कुट",
  "item.minecraft.filled_map": "मानचित्र□#0",
  "item.minecraft.shears": "कैंची",
  "item.minecraft.melon_slice": "तरबूज का टुकड़ा",
  "item.minecraft.dried_kelp": "सूखा सिवार",
  "item.minecraft.pumpkin_seeds": "कद्दू के बीज",
  "item.minecraft.melon_seeds": "तरबूज के बीज",
  "item.minecraft.beef": "कच्चा गोमांस",
  "item.minecraft.cooked_beef": "पक्व गोमांस",
  "item.minecraft.chicken": "कच्चा मुर्गी",
  "item.minecraft.cooked_chicken": "पक्व मुर्गी",
  "item.minecraft.rotten_flesh": "सड़े हुए माँस",
  "item.minecraft.ender_pearl": "अंतिम मोती",
  "item.minecraft.blaze_rod": "ज्वाला छड़",
  "item.minecraft.ghast_tear": "घास्ट का आँसू",
  "item.minecraft.gold_nugget": "सोने का डला",
  "item.minecraft.nether_wart": "निचला मस्सा",
  "item.minecraft.potion": "अनौचेंबल पोशन□कोई प्रभाव नहीं",
  "item.minecraft.glass_bottle": "काँच की शीशी",
  "item.minecraft.spider_eye": "मकड़ी की आँख",
  "item.minecraft.fermented_spider_eye": "किण्वित स्पाइडर आँखों",
  "item.minecraft.blaze_powder": "ब्लेज़ पाउडर",
  "item.minecraft.magma_cream": "लावा क्रीम",
  "block.minecraft.brewing_stand": "पक खड़े हो जाओ",
  "block.minecraft.cauldron": "देग",
  "item.minecraft.ender_eye": "के नेत्र अंत",
  "item.minecraft.glistering_melon_slice": "चमकीला तरबूज का टुकडा",
  "item.minecraft.bat_spawn_egg": "चमगादड़ का जन्म अंडा",
  "item.minecraft.bee_spawn_egg": "मधुमक्खी का जन्म अंडा",
  "item.minecraft.blaze_spawn_egg": "ब्लेज का जन्म अंडा",
  "item.minecraft.cat_spawn_egg": "बिल्ली का जन्म अंडा",
  "item.minecraft.cave_spider_spawn_egg": "गुफावाली मकड़ी का जन्म अंडा",
  "item.minecraft.chicken_spawn_egg": "मुर्गी का जन्म अंडा",
  "item.minecraft.cod_spawn_egg": "कॉड का जन्म अंडा",
  "item.minecraft.cow_spawn_egg": "गाय का जन्म अंडा",
  "item.minecraft.creeper_spawn_egg": "क्रीपर का जन्म अंडा",
  "item.minecraft.dolphin_spawn_egg": "सूंस का जन्म अंडा",
  "item.minecraft.donkey_spawn_egg": "गधा का जन्म अंडा",
  "item.minecraft.drowned_spawn_egg": "डूबा हुआ जॉम्बी का जन्म अंडा",
  "item.minecraft.elder_guardian_spawn_egg": "बड़े संरक्षक अंडे",
  "item.minecraft.enderman_spawn_egg": "एन्डरमैन का जन्म अंडा",
  "item.minecraft.endermite_spawn_egg": "एन्डरमाइट का जन्म अंडा",
  "item.minecraft.evoker_spawn_egg": "जन्म अंडा",
  "item.minecraft.fox_spawn_egg": "लोमड़ी का जन्म अंडा",
  "item.minecraft.ghast_spawn_egg": "घास्ट का जन्म अंडा",
  "item.minecraft.guardian_spawn_egg": "बड़े संरक्षक अंडे",
  "item.minecraft.hoglin_spawn_egg": "हॉग्लीन का जन्म अंडा",
  "item.minecraft.horse_spawn_egg": "घोड़ा जन्म अंडा",
  "item.minecraft.husk_spawn_egg": "सूखा जॉम्बी जन्म अंडा",
  "item.minecraft.llama_spawn_egg": "लामा का जन्म अंडा",
  "item.minecraft.magma_cube_spawn_egg": "मैग्मा घन जन्म अंडा",
  "item.minecraft.mooshroom_spawn_egg": "मूशरूम का जन्म अंडा",
  "item.minecraft.mule_spawn_egg": "खच्चर जन्म अंडा",
  "item.minecraft.ocelot_spawn_egg": "ऑसलॉट का जन्म अंडा",
  "item.minecraft.panda_spawn_egg": "पाँडा का जन्म अंडा",
  "item.minecraft.parrot_spawn_egg": "तोता का जन्म अंडा",
  "item.minecraft.phantom_spawn_egg": "घोस्ट जन्म अंडा",
  "item.minecraft.pig_spawn_egg": "सूअर का जन्म अंडा",
  "item.minecraft.piglin_spawn_egg": "पिगलीन का जन्म अंडा",
  "item.minecraft.pillager_spawn_egg": "लुटेरा का जन्म अंडा",
  "item.minecraft.polar_bear_spawn_egg": "ध्रुवीय भालू का जन्म अंडा",
  "item.minecraft.pufferfish_spawn_egg": "आध्मादतक मछली का जन्म अंडा",
  "item.minecraft.rabbit_spawn_egg": "खरगोश का जन्म अंडा",
  "item.minecraft.ravager_spawn_egg": "ग्रामबासी के अंडे",
  "item.minecraft.salmon_spawn_egg": "सैल्मन का जन्म अंडा",
  "item.minecraft.sheep_spawn_egg": "भेड़ का जन्म अंडा",
  "item.minecraft.shulker_spawn_egg": "शल्कर का जन्म अंडा",
  "item.minecraft.silverfish_spawn_egg": "सिल्वरफिश के अंडे",
  "item.minecraft.skeleton_spawn_egg": "कंकाल के अंडे",
  "item.minecraft.skeleton_horse_spawn_egg": "कंकाल घोड़े के अंडे",
  "item.minecraft.slime_spawn_egg": "स्लाइम का जन्म अंडा",
  "item.minecraft.spider_spawn_egg": "मकड़ी का जन्म अंडा",
  "item.minecraft.squid_spawn_egg": "स्क्वीड के अंडे",
  "item.minecraft.stray_spawn_egg": "जानबर का जन्म अंडा",
  "item.minecraft.strider_spawn_egg": "स्ट्राईडर का जन्म अंडा",
  "item.minecraft.trader_llama_spawn_egg": "ट्रेडर लामा",
  "item.minecraft.tropical_fish_spawn_egg": "उष्णकटिबंधीय मछली के अंडे",
  "item.minecraft.turtle_spawn_egg": "कछुआ का जन्म अंडा",
  "item.minecraft.vex_spawn_egg": "वेक्स स्पॉन एग",
  "item.minecraft.villager_spawn_egg": "ग्रामवासी के अंडे",
  "item.minecraft.vindicator_spawn_egg": "ग्रामवासी के एग",
  "item.minecraft.wandering_trader_spawn_egg": "पर्यटक व्यापारी का जन्म अंड़ा",
  "item.minecraft.witch_spawn_egg": "डायन का जन्म अंडा",
  "item.minecraft.wither_skeleton_spawn_egg": "विदर कंकाल का जन्म अंडा",
  "item.minecraft.wolf_spawn_egg": "भेड़िया का जन्म अंडा",
  "item.minecraft.zoglin_spawn_egg": "ज़ॉग्लीन का जन्म अंडा",
  "item.minecraft.zombie_spawn_egg": "जॉम्बी का जन्म अंडा",
  "item.minecraft.zombie_horse_spawn_egg": "जोंबी होर्श स्पाॅन एग",
  "item.minecraft.zombie_villager_spawn_egg": "जोंबी विलेजर स्पान एग",
  "item.minecraft.zombified_piglin_spawn_egg": "जोम्बी पिगलीन का जन्म अंडा",
  "item.minecraft.experience_bottle": "बोतल ओ' करामाती",
  "item.minecraft.fire_charge": "आग प्रभार",
  "item.minecraft.writable_book": "किताब और कलम",
  "item.minecraft.written_book": "व्रित्तें बुक",
  "item.minecraft.emerald": "पन्ना",
  "item.minecraft.item_frame": "आइटम सीमा",
  "block.minecraft.flower_pot": "गमला",
  "item.minecraft.carrot": "गाजर",
  "item.minecraft.potato": "आलू",
  "item.minecraft.baked_potato": "सेका हुआ आलू",
  "item.minecraft.poisonous_potato": "जहरीला आलू",
  "item.minecraft.map": "खाली मानचित्र",
  "item.minecraft.golden_carrot": "सोने का गाजर",
  "block.minecraft.skeleton_skull": "कंकाल की खोपड़ी",
  "block.minecraft.wither_skeleton_skull": "विदर कंकाल खोपड़ी",
  "block.minecraft.player_head": "खिलाड़ी का सिर",
  "block.minecraft.zombie_head": "जॉम्बी का सिर",
  "block.minecraft.creeper_head": "क्रीपर का सिर",
  "block.minecraft.dragon_head": "ड्रैगन सिर",
  "item.minecraft.carrot_on_a_stick": "डंडा पर गाजर",
  "item.minecraft.warped_fungus_on_a_stick": "डंडे पर विकृत कवक",
  "item.minecraft.nether_star": "नेदर सितारा",
  "item.minecraft.pumpkin_pie": "कद्दू पाई",
  "item.minecraft.firework_rocket": "आतिशबाजी रॉकेट",
  "item.minecraft.firework_star": "आतिशबाजी सितारा",
  "item.minecraft.enchanted_book": "जादूई पुस्तक",
  "item.minecraft.nether_brick": "नेदर ईंट",
  "item.minecraft.quartz": "नेदर स्फटिक",
  "item.minecraft.tnt_minecart": "गाड़ी में टीएनटी",
  "item.minecraft.hopper_minecart": "हूपर के साथ minecart",
  "item.minecraft.prismarine_shard": "प्रिज्मरीन का टुकड़ा",
  "item.minecraft.prismarine_crystals": "प्रिज्मरीन का क्रिस्टल",
  "item.minecraft.rabbit": "कच्चा खरगोश",
  "item.minecraft.cooked_rabbit": "पक्व खरगोश",
  "item.minecraft.rabbit_stew": "खरगोश का खिचड़ी",
  "item.minecraft.rabbit_foot": "खरगोश की पैर",
  "item.minecraft.rabbit_hide": "खरगोश की खाल",
  "item.minecraft.armor_stand": "पुतला",
  "item.minecraft.iron_horse_armor": "लौह हार्स कवच",
  "item.minecraft.golden_horse_armor": "सोने का घोङे का कवच",
  "item.minecraft.diamond_horse_armor": "डायमंड हार्स कवच",
  "item.minecraft.leather_horse_armor": "चमड़े का घोड़ा कवच",
  "item.minecraft.lead": "डोरी",
  "item.minecraft.name_tag": "नाम टैग",
  "item.minecraft.command_block_minecart": "minecart आदेश ब्लॉक के साथ",
  "item.minecraft.mutton": "कच्चा मटन",
  "item.minecraft.cooked_mutton": "पक्व भेड़",
  "block.minecraft.white_banner": "सफेद झंडा",
  "block.minecraft.orange_banner": "नारंगी झंडा",
  "block.minecraft.magenta_banner": "नीलातिरक्त झंडा",
  "block.minecraft.light_blue_banner": "हल्का नीला झंडा",
  "block.minecraft.yellow_banner": "पीला झंडा",
  "block.minecraft.lime_banner": "लाइम झंडा",
  "block.minecraft.pink_banner": "गुलाबी झंडा",
  "block.minecraft.gray_banner": "स्लेटी झंडा",
  "block.minecraft.light_gray_banner": "हल्का स्लेटी झंडा",
  "block.minecraft.cyan_banner": "हरिनील झंडा",
  "block.minecraft.purple_banner": "जामुनी झंडा",
  "block.minecraft.blue_banner": "नीला झंडा",
  "block.minecraft.brown_banner": "भूरा झंडा",
  "block.minecraft.green_banner": "हरा झंडा",
  "block.minecraft.red_banner": "लाल झंडा",
  "block.minecraft.black_banner": "काला झंडा",
  "item.minecraft.end_crystal": "अंत क्रिस्टल",
  "item.minecraft.chorus_fruit": "कोरस का फल",
  "item.minecraft.popped_chorus_fruit": "popped कोरस फल",
  "item.minecraft.beetroot": "चुकंदर",
  "item.minecraft.beetroot_seeds": "चुकंदर के बीज",
  "item.minecraft.beetroot_soup": "चुकंदर का रस",
  "item.minecraft.dragon_breath": "ड्रैगन की सांस",
  "item.minecraft.splash_potion": "स्पलैश अनूर््वनेबल पोशन□कोई प्रभाव नहीं",
  "item.minecraft.spectral_arrow": "स्पेक्ट्रल एरो",
  "item.minecraft.tipped_arrow": "अनवरनीय इत्तला दे दी एरो□कोई प्रभाव नहीं",
  "item.minecraft.lingering_potion": "लिन्दरिंग यून्राक्टेबल औषधि□कोई प्रभाव नहीं",
  "item.minecraft.shield": "ढाल",
  "item.minecraft.elytra": "पक्षवर्म",
  "item.minecraft.spruce_boat": "प्रसरल की नाव",
  "item.minecraft.birch_boat": "भूर्ज की नाव",
  "item.minecraft.jungle_boat": "जंगल की नाव",
  "item.minecraft.acacia_boat": "बबूल की नाव",
  "item.minecraft.dark_oak_boat": "काला बाँज की नाव",
  "item.minecraft.totem_of_undying": "अमर की कुलदेवता",
  "item.minecraft.shulker_shell": "शल्कर का खोल",
  "item.minecraft.iron_nugget": "लोहे का डला",
  "item.minecraft.knowledge_book": "ज्ञान पुस्तक",
  "item.minecraft.debug_stick": "दोषमार्जन डंडा",
  "item.minecraft.music_disc_13": "संगीत चक्रिका□c418 - 13",
  "item.minecraft.music_disc_cat": "संगीत चक्रिका□c418 - cat",
  "item.minecraft.music_disc_blocks": "संगीत चक्रिका□c418 - blocks",
  "item.minecraft.music_disc_chirp": "संगीत चक्रिका□c418 - chirp",
  "item.minecraft.music_disc_far": "संगीत चक्रिका□c418 - far",
  "item.minecraft.music_disc_mall": "संगीत चक्रिका□c418 - mall",
  "item.minecraft.music_disc_mellohi": "संगीत चक्रिका□c418 - mellohi",
  "item.minecraft.music_disc_stal": "संगीत चक्रिका□c418 - stal",
  "item.minecraft.music_disc_strad": "संगीत चक्रिका□c418 - strad",
  "item.minecraft.music_disc_ward": "संगीत चक्रिका□c418 - ward",
  "item.minecraft.music_disc_11": "संगीत चक्रिका□c418 - 11",
  "item.minecraft.music_disc_wait": "संगीत चक्रिका□c418 - wait",
  "item.minecraft.music_disc_pigstep": "संगीत चक्रिका□लेना रैन - pigstep",
  "item.minecraft.trident": "त्रिशूल□□जब मुख्य हाथ में है:□+8 हमले क्षति□-2.9 हमले की गति",
  "item.minecraft.phantom_membrane": "प्रेत झिल्ली",
  "item.minecraft.nautilus_shell": "नॉटिलस शैल",
  "item.minecraft.heart_of_the_sea": "समुद्र का हृदय",
  "item.minecraft.crossbow": "आड़ी कमान",
  "item.minecraft.suspicious_stew": "संदिग्ध शोरबा",
  "block.minecraft.loom": "करघा",
  "item.minecraft.flower_banner_pattern": "झंडा का आकृति□फूल का अभिकल्प",
  "item.minecraft.creeper_banner_pattern": "झंडा का आकृति□क्रीपर का अभिकल्प",
  "item.minecraft.skull_banner_pattern": "झंडा का आकृति□खोपड़ी का अभिकल्प",
  "item.minecraft.mojang_banner_pattern": "झंडा का आकृति□चीज",
  "item.minecraft.globe_banner_pattern": "झंडा का आकृति□ग्लोब",
  "item.minecraft.piglin_banner_pattern": "झंडा का आकृति□थूथन",
  "block.minecraft.composter": "खाद का डब्बा",
  "block.minecraft.barrel": "पीपा",
  "block.minecraft.smoker": "तंदूर",
  "block.minecraft.blast_furnace": "वात्या भट्ठी",
  "block.minecraft.cartography_table": "मानचित्रकला मेज",
  "block.minecraft.fletching_table": "फैलेटिंग टेबल",
  "block.minecraft.grindstone": "सान",
  "block.minecraft.lectern": "ज्ञानतीठ",
  "block.minecraft.smithing_table": "स्मिथिंग टेबल",
  "block.minecraft.stonecutter": "संगतराश",
  "block.minecraft.bell": "घंटी",
  "block.minecraft.lantern": "कंदील",
  "block.minecraft.soul_lantern": "आत्माओं का फानूस",
  "item.minecraft.sweet_berries": "मीठे फल",
  "block.minecraft.campfire": "अलाव",
  "block.minecraft.soul_campfire": "आत्मा का अलाव",
  "block.minecraft.shroomlight": "छत्रकदीप",
  "item.minecraft.honeycomb": "मधुकोष",
  "block.minecraft.bee_nest": "मधुमक्खी का घोंसला",
  "block.minecraft.beehive": "मधुमक्खी का छत्ता",
  "item.minecraft.honey_bottle": "शहद की बोतल",
  "block.minecraft.honey_block": "मधु प्रखंड",
  "block.minecraft.honeycomb_block": "मधुकोष का खंड",
  "block.minecraft.lodestone": "चुंबक पत्थर",
  "block.minecraft.netherite_block": "नेदराइट का प्रखंड",
  "block.minecraft.ancient_debris": "प्राचीन अवशेष",
  "block.minecraft.target": "निशाना",
  "block.minecraft.crying_obsidian": "रोनेवाला ज्वालाकाच",
  "block.minecraft.blackstone": "कालापाषाण",
  "block.minecraft.blackstone_slab": "कालापाषाण की पटिया",
  "block.minecraft.blackstone_stairs": "कालापाषाण की सीढ़ियाँ",
  "block.minecraft.gilded_blackstone": "मुलम्मा चढ़े कालापाषाण",
  "block.minecraft.polished_blackstone": "चमकदार कालापाषाण",
  "block.minecraft.polished_blackstone_slab": "चमकदार कालापाषाण की पटिया",
  "block.minecraft.polished_blackstone_stairs": "चमकदार कालापाषाण की सीढ़ियाँ",
  "block.minecraft.chiseled_polished_blackstone": "तराशा हुआ चमकदार कालापाषाण",
  "block.minecraft.polished_blackstone_bricks": "चमकदार कालापाषाण की ईंटें",
  "block.minecraft.polished_blackstone_brick_slab": "चमकदार कालापाषाण की ईंट की पटिया",
  "block.minecraft.polished_blackstone_brick_stairs": "चमकदार कालापाषाण की ईंट की सीढ़ियाँ",
  "block.minecraft.cracked_polished_blackstone_bricks": "टूटे हुए चमकदार कालापाषाण की ईंटें",
  "block.minecraft.respawn_anchor": "पुनर्जन्म का स्थिरक",
}
export const hi_in = items; 
